/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useState } from 'react';
import classNames from 'classnames/bind';

import { RegistrationContext } from '../../../../../contexts';
import { RegistrationActions } from '../../../../../contexts/RegistrationContext/RegistrationReducer';
import { FancyField } from '../../../../../components/fancyFieldsV2';
import { formatCents } from '../../../../../utils';
import styles from '../../../../../styles/main.module.scss';

const { UPDATE_REGISTRATION_STATE } = RegistrationActions;
const cx = classNames.bind(styles);

type PromoCodeFormProps = {
  isDropIn?: boolean;
};

const PromoCodeForm: React.FC<PromoCodeFormProps> = ({ isDropIn = false }) => {
  const [promoCode, setPromoCode] = useState('');
  const [isEditingPromo, setIsEditingPromo] = useState(false);

  // @ts-ignore: RegistrationContext is not migrated to TypeScript yet
  const [registerState, registerDispatch] = useContext(RegistrationContext);
  const {
    pricingBreakdown: nonDropInPricingBreakdown,
    promoCodeMessage,
    dropInPriceData,
    addVpMembership,
    addVpTrial,
  } = registerState;

  const dropInPricing = dropInPriceData?.dropinPricingForRegistration ?? {};

  const { currentUserPaymentCriteria, promoCodeMessage: dropInPromoCodeMessage } = dropInPricing;
  const dropinBreakdown =
    addVpMembership || addVpTrial ? 'memberBreakdown' : currentUserPaymentCriteria;

  // Select the correct Pricing Breakdown and Promo Code information based on if
  // the form is meant for a Drop-in
  const promoErrorMessage = isDropIn ? dropInPromoCodeMessage : promoCodeMessage;
  const pricingBreakdown = isDropIn
    ? dropInPricing?.[dropinBreakdown] // Selects the correct one based on member/nonMember
    : nonDropInPricingBreakdown;

  const { promoCode: promoDetails, promoDiscountCents } = pricingBreakdown || {};

  return (
    <>
      <div className="d-flex justify-content-between">
        {isEditingPromo ? (
          <>
            <FancyField
              value={promoCode}
              onChange={(value: string) => setPromoCode(value)}
              placeholder="Enter promo"
              blockStyle
              noLabel
              inputStyle={{
                width: '40%',
              }}
              className="col-6 p-0 text-right"
            />
            <div className={cx('promo-code-controls')}>
              <a
                className={cx('apply-button')}
                role="button"
                tabIndex={0}
                onClick={() => {
                  registerDispatch({
                    type: UPDATE_REGISTRATION_STATE,
                    update: {
                      appliedPromo: promoCode,
                    },
                  });
                  setIsEditingPromo(false);
                }}
              >
                Apply
              </a>
              <a
                className={cx('cancel-button')}
                role="button"
                tabIndex={0}
                onClick={() => {
                  setIsEditingPromo(false);
                  setPromoCode('');
                }}
              >
                Cancel
              </a>
            </div>
          </>
        ) : (
          <>
            <span className={cx('cursor-pointer', 'col-5 px-0')}>Promo Code</span>
            <a
              className={cx('underline', 'col-7 p-0 text-right')}
              role="button"
              tabIndex={0}
              onClick={() => setIsEditingPromo(true)}
            >
              Enter Code
            </a>
          </>
        )}
      </div>
      {promoDetails && (
        <div className={cx('d-flex justify-content-between')}>
          <span>Promo Applied!&nbsp;{promoDetails?.promoCodeStr}</span>
          <span>-{formatCents(promoDiscountCents)}</span>
        </div>
      )}
      {promoErrorMessage && (
        <p className={cx('text-danger text-center pt-1 font-weight-bold')}>{promoErrorMessage}</p>
      )}
    </>
  );
};

export default PromoCodeForm;
